import { getDateTime } from 'src/utils/getDateTime';
import { plural } from 'src/utils/plural';
import { validateTimeRange } from 'src/utils/validations/validateTimeRange';

const maxDurationInDays = 60;

export interface DateBounds {
  min: Date | undefined;
  max: Date | undefined;
}

export const calculateDateBounds = (timezoneOffset: number): DateBounds => {
  const min = getDateTime({
    timezoneOffset,
  });
  let max: Date | undefined = new Date();
  min.setDate(min.getDate() - 1);
  max.setDate(max.getDate() + maxDurationInDays);
  max = getDateTime({
    date: max,
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999,
    timezoneOffset,
  });

  return { min, max };
};

export const minIntervalMinutes = 15;
const minIntervalMs = minIntervalMinutes * 60 * 1000;
const errorMessage = `Не менее ${minIntervalMinutes} ${plural(
  minIntervalMinutes,
  {
    zero: 'минут',
    one: 'минуты',
    two: 'минут',
    few: 'минуты',
    many: 'минут',
    other: 'минут',
  },
)}`;

export const calculateParkingTimeError = (
  date: string | undefined,
  from: string | undefined,
  to: string | undefined,
  timezoneOffset: number | undefined,
): string | undefined => {
  return validateTimeRange({
    date,
    from,
    to,
    diffMs: minIntervalMs,
    message: errorMessage,
    timezoneOffset,
  });
};
